import { Navigate } from 'react-router-dom';
import { useTenant } from '../components/TenantContext.jsx';
import { useAuth } from '../auth/AuthContext.jsx';

/**
 * 登入後的預設落地頁：
 *   授權管理專職帳號 license_admin@tecom.com → /sdx500（它只看得到這一頁）
 *   super_admin → /admin（超管中心）
 *   admin (母帳號) → /tenants（先看設定有沒有齊）
 *   其他 (agent / viewer / 沒角色) → /calls
 */
export default function HomeRedirect() {
    const { loading, isAdmin, isSuperAdmin } = useTenant();
    const { user } = useAuth();

    if (loading) {
        return (
            <div className="grid min-h-[60vh] place-items-center text-ink-500">
                <div className="font-mono text-sm">Loading…</div>
            </div>
        );
    }
    if ((user?.email || '').toLowerCase() === 'license_admin@tecom.com') return <Navigate to="/sdx500" replace />;
    if (isSuperAdmin) return <Navigate to="/admin" replace />;
    return <Navigate to={isAdmin ? '/tenants' : '/calls'} replace />;
}
